import React from "react";
import { Button } from "react-bootstrap";
import Glyphicon from "glyphicons";
import "./LoaderButton.css";

export default ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  style,
  ...props
}) => (
  <Button
    id="loaderButtonId"
    className={`LoaderButton ${className}`}
    disabled={disabled || isLoading}
    style={style}
    {...props}
  >
    {isLoading && <span className="glyphicon glyphicon-refresh glyphicon-spin"></span>}
    {!isLoading ? text : loadingText}
  </Button>
);
